import { render, staticRenderFns } from "./StepWelcome.vue?vue&type=template&id=8cc52566&"
import script from "./StepWelcome.vue?vue&type=script&lang=js&"
export * from "./StepWelcome.vue?vue&type=script&lang=js&"
import style0 from "./StepWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports